import script from "./TextInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextInput.vue?vue&type=script&setup=true&lang=ts"

import "./TextInput.vue?vue&type=style&index=0&id=43b4fd92&scoped=true&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43b4fd92"]])

export default __exports__